module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\" gis-map-controls-zoom gis-zoom-control\">\n    <div class='gis-map-controls-plus plus' title='Приблизить' on-click=\"onZoomInClick\">\n        <div class=\"icon-24 icon-search-plus\"></div>\n    </div>\n    <div class='gis-map-controls-minus minus' title='Отдалить' on-click=\"onZoomOutClick\">\n        <div class=\"icon-24 icon-search-minus\"></div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}